module.exports = __webpack_public_path__ + "img/05—Applications—Speed Test 04 > WLAN Download.216601f3.jpg";